// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3BTAQ","row":"Node_row__EPqxS","label":"Node_label__2y7nC","footer":"Node_footer__2xmNc"};